<template id="login_template">
<div>

<body>
  <div class="container">
    <div class="row">
      <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
        <div class="card card-signin my-5">
          <div class="card-body">
            <h5 class="card-title text-center">Sign In to Zoom App</h5>
              <div class="form-label-group">
                 <label for="inputEmail">Email address</label><br>
                <input type="email" id="inputEmail" class="form-control"  v-model="user.username" placeholder="Email address" required autofocus>
               
              </div>

              <div class="form-label-group">
                 <label for="inputPassword">Password</label><br>
                <input type="password" id="inputPassword" class="form-control" v-model="user.password" placeholder="Password" required>
               
              </div>

              <button class="btn btn-lg btn-primary btn-block text-uppercase" @click="handleLogin">Sign in</button>
              <hr class="my-4">
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
</div>
</template>

<script>
import User from '../models/user';
import { mapMutations } from 'vuex'
import store from '../store/index.js'
import API from '../services/api.js'
export default {
  name: 'Login',
  data() {
    return {
      user: new User('', ''),
      loading: false,
      message: ''
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.loggedIn;
    }
  },
  methods: {
    ...mapMutations([
      'getUserSuccess'
    ]),
    async handleLogin() {
      this.loading = true;
      if (this.user.username && this.user.password) {
         API.post('/api/admin/login',{email: this.user.username,password:this.user.password})
          .then(({data,status}) => {
            if(status == 400){
              this.$notification["error"]({
                  message: "Error",
                  description: "Your email or password is wrong!",
                });
            }
            if (data.data.access_token) {
                localStorage.setItem('access_token', data.data.access_token);
                localStorage.setItem('refresh_token', data.data.refreshtoken);
                this.$store.dispatch('auth/getUser')
                .then(response => {
                  store.commit('auth/getUserSuccess',response.data.profile)
                  this.$router.push('/admin');
                })
              }
          })
        // this.$store.dispatch('auth/login', this.user).then(
        //   () => {
        //     this.$router.push('/dashboard');
        //   },
        //   error => {
        //     this.loading = false;
        //     this.message =
        //       (error.response && error.response.data) ||
        //       error.message ||
        //       error.toString();
        //   }
        //   );
        }
    }
  }
};
</script>

<style scoped>

.card-signin {
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
}

.card-signin .card-title {
  margin-bottom: 2rem;
  font-weight: 300;
  font-size: 1.5rem;
}

.card-signin .card-body {
  padding: 2rem;
}

.form-signin {
  width: 100%;
}

.form-signin .btn {
  font-size: 80%;
  border-radius: 5rem;
  letter-spacing: .1rem;
  font-weight: bold;
  padding: 1rem;
  transition: all 0.2s;
}

.form-label-group {
  position: relative;
  margin-bottom: 1rem;
}

.form-label-group input {
  border-radius: 2rem;
}

.form-label-group>input,
.form-label-group>label {
  padding: var(--input-padding-y) var(--input-padding-x);
}

.form-label-group>label {
  position: absolute;
  top: 10;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0;
  /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
  padding-bottom: calc(var(--input-padding-y) / 3);
}

.form-label-group input:not(:placeholder-shown)~label {
  padding-top: calc(var(--input-padding-y) / 3);
  padding-bottom: calc(var(--input-padding-y) / 3);
  font-size: 12px;
  color: #777;
}



/* Fallback for Edge
-------------------------------------------------- */

@supports (-ms-ime-align: auto) {
  .form-label-group>label {
    display: none;
  }
  .form-label-group input::-ms-input-placeholder {
    color: #777;
  }
}

/* Fallback for IE
-------------------------------------------------- */

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {
  .form-label-group>label {
    display: none;
  }
  .form-label-group input:-ms-input-placeholder {
    color: #777;
  }
}
</style>